import React from 'react';
import HindiDiwas2025 from 'views/HindiDiwas2025'

const SchoolProgrampage = () => {
  return <HindiDiwas2025 />;
};

export default SchoolProgrampage;